'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var money = require('@circlefin/money');

/**
 * Hook to return a money formatter for custom currencies.
 */ function useCustomMoney({ locale } = {}) {
    /**
     * Money formatter for custom currencies.
     * @returns Formatted number based on currency configuration.
     */ const customMoney = react.useCallback(({ number, currencyConfig, options })=>money.moneyFormat(number, currencyConfig, locale ?? [], options)?.formattedMoney ?? '', [
        locale
    ]);
    return {
        customMoney
    };
}

exports.default = useCustomMoney;
exports.useCustomMoney = useCustomMoney;
//# sourceMappingURL=useCustomMoney.js.map
